import { render, staticRenderFns } from "./hotelDirectList.vue?vue&type=template&id=b708b392&scoped=true"
import script from "./hotelDirectList.vue?vue&type=script&lang=js"
export * from "./hotelDirectList.vue?vue&type=script&lang=js"
import style0 from "./hotelDirectList.vue?vue&type=style&index=0&id=b708b392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b708b392",
  null
  
)

export default component.exports